export default `
query Affiliates($gameId: ID!, $filters: [FilterCriterion], $sorting: [SortingCriterion], $pagination: Pagination) {
  affiliates(gameId: $gameId, filters: $filters, sorting: $sorting, pagination: $pagination) {
    items {
      name
      ticketCount
    }
    errors {
      message
      code
      path
    }
    meta {
      totalCount
      pageSize
      pageCount
    }
  }
}
`;
